var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerSetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.b,.f,.j{fill:#3c3c46;}.b{opacity:0.15;}.c{fill:#89d9fb;}.c,.d,.e,.g,.h,.i,.k{stroke:#3c3c46;stroke-linejoin:round;stroke-width:2px;}.c,.d,.e,.g,.i,.k{stroke-linecap:round;}.d,.e,.g,.h,.i,.j,.k{fill-rule:evenodd;}.e{fill:#ffec00;}.g{fill:#3ca4ef;}.h{fill:#f2424c;}.i{fill:#fff;}.j{opacity:0.2;}.k{fill:#ffefe0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-set-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 20,
    y: 20,
    width: 106,
    height: 106,
    rx: 5.78,
    ry: 5.78
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 14,
    y: 14,
    width: 106,
    height: 106,
    rx: 5.78,
    ry: 5.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44,110A20,20,0,1,0,24,90,20,20,0,0,0,44,110Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M90,110A20,20,0,1,0,70,90,20,20,0,0,0,90,110Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44,64A20,20,0,1,0,24,44,20,20,0,0,0,44,64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.07,50.16A20,20,0,1,1,83.84,24.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M44,104A14,14,0,1,0,30,90,14,14,0,0,0,44,104Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M52.79,92.39a9.1,9.1,0,0,1-17.57,0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 48.76,
    cy: 86.8,
    r: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 39.24,
    cy: 86.8,
    r: 1.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M50.19,38.28l-1.94,1.94a5.4,5.4,0,1,0,0,7.63l6.08,6.08a14,14,0,1,1,0-19.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M102,87.62a6.48,6.48,0,0,0-12-3.38,6.48,6.48,0,1,0-9.78,8.26l9.18,9.18a.84.84,0,0,0,1.18,0l9.18-9.18a6.51,6.51,0,0,0,1.62-2.15A6.43,6.43,0,0,0,102,87.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M90.12,38.79h0a3.84,3.84,0,0,0-7.61-.46h-.13a3.1,3.1,0,0,0-3,2.2h-.18a2,2,0,0,0,0,4h10.9a2.87,2.87,0,0,0,0-5.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M84.74,46.16h0a5.09,5.09,0,0,1,10.08-.61H95a4.11,4.11,0,0,1,3.93,2.92h.24a2.65,2.65,0,0,1,0,5.31H84.74a3.8,3.8,0,0,1,0-7.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M102.91,52.7c-11.06,3.14-20-3.29-20-14.35a22.71,22.71,0,0,1,1-6.41v0L109.07,50,109,50A25.11,25.11,0,0,1,102.91,52.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M102.92,51.1A20,20,0,0,1,83.84,24.93v0l25.23,25.23-.08,0A20,20,0,0,1,102.92,51.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M89.93,24A20,20,0,0,1,109,50.15v0L83.77,24.94l.08,0A20,20,0,0,1,89.93,24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerSetIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-set-icon.12731adff0b7d83f81facd69c81b9a11.svg";
export { ForwardRef as ReactComponent };